import axios from 'axios';
import axiosInstance from './AxiosService';

const auditService = {

// RISK Library

  fetchRisk: async () => {
    const response = await axiosInstance.get(`audit/risk/`);
    return response.data;
  },

  fetchRiskById: async (riskID) => {
    const response = await axiosInstance.get(`audit/risk/${riskID}/`);
    return response.data;
},

  createRisk: async (riskData) => {
    const response = await axiosInstance.post(`audit/risk/`, riskData);
    return response.data;
  }, 

  updateRisk: async (riskID, riskData) => {
    try {
      console.log(`Attempting to update risk: ${riskID}`);
      console.log(`Request data:`, riskData);
      
      // Ensure we're using id consistently for the API call
      const endpoint = `audit/risk/${riskData.id || riskID}/`;
      console.log(`Using endpoint: ${endpoint}`);
      
      const response = await axiosInstance.put(endpoint, riskData);
      console.log('Update successful');
      return response.data;
    } catch (error) {
      console.error(`Error updating risk:`, error.message);
      if (error.response) {
        console.error('Server response code:', error.response.status);
        console.error('Server response data:', error.response.data);
      }
      throw error;
    }
  },

  deleteRisk: async (riskID) => {
    const response = await axiosInstance.delete(`audit/risk/${riskID}/`);
    return response.data;
  },
  

  //CONTROLS LIBRARY
  
  fetchControls: async () => {
    const response = await axiosInstance.get(`audit/controls/`);
    return response.data;
  },

  fetchControlsById: async (controlID) => {
    const response = await axiosInstance.get(`audit/controls/${controlID}/`);
    return response.data;
  },

  createControls: async (controlData) => {
    const response = await axiosInstance.post(`audit/controls/`, controlData);
    return response.data;
  }, 

  updateControls: async (controlID, controlData) => {
    const response = await axiosInstance.put(`audit/controls/${controlID}/`, controlData);
    return response.data;
  },

  deleteControls: async (controlID) => {
    const response = await axiosInstance.delete(`audit/controls/${controlID}/`);
    return response.data;
  },

  //PROJECTS LIBRARY

  fetchProjects: async () => {
    const response = await axiosInstance.get(`audit/projects/`);
    return response.data;
  },

  fetchProjectsById: async (auditID) => {
    const response = await axiosInstance.get(`audit/projects/${auditID}/`);
    return response.data;
  },

  createProjects: async (projectData) => {
    const response = await axiosInstance.post(`audit/projects/`, projectData);
    return response.data;
  }, 

  updateProjects: async (auditID, projectData) => {
    const response = await axiosInstance.put(`audit/projects/${auditID}/`, projectData);
    return response.data;
  },

  deleteProjects: async (auditID) => {
    const response = await axiosInstance.delete(`audit/projects/${auditID}/`);
    return response.data;
  },

  //RISK MAPPING

  fetchRiskMapping: async () => {
    const response = await axiosInstance.get(`audit/riskmapping/`);
    return response.data;
  },

  fetchRiskMappingbyId: async (APP_NAME, COMPANY_ID) => {
    const response = await axiosInstance.get(`audit/mapping/${APP_NAME}/${COMPANY_ID}/`);
    return response.data;
  },

  fetchRiskMappingbyCompany: async (COMPANY_ID) => {
    const response = await axiosInstance.get(`audit/mapping/company/${COMPANY_ID}/`);
    return response.data;
  },


  createRiskMapping: async (riskmappingData) => {
    const response = await axiosInstance.post(`audit/riskmapping/`, riskmappingData);
    return response.data;
  }, 

  updateRiskMappingbyMapID: async (APP_NAME, RISK_ID, COMPANY_ID, updatedData) => {
    const response = await axiosInstance.put(`audit/riskmapping/delete/${APP_NAME}/${RISK_ID}/${COMPANY_ID}/`,updatedData);
    return response.data;
  },

  updateRiskRating: async (APP_NAME, RISK_ID, COMPANY_ID, ratingData) => {
    const response = await axiosInstance.put(`audit/riskmapping/delete/${APP_NAME}/${RISK_ID}/${COMPANY_ID}/`, ratingData);
    return response.data;
  },

  fetchRiskMappingbyApp: async (APP_NAME, COMPANY_ID) => {
    const response = await axiosInstance.get(`audit/mapping/app/${APP_NAME}/${COMPANY_ID}/`);
    return response.data;
  },

  fetchMappedControls: async (APP_NAME, RISK_ID, COMPANY_ID) => {
    const response = await axiosInstance.get(`audit/mapping/controls/${APP_NAME}/${RISK_ID}/${COMPANY_ID}/`);
    return response.data;
  },

  deleteRiskMappingbyMapID: async (APP_NAME, RISK_ID, COMPANY_ID) => {
    const response = await axiosInstance.delete(`audit/riskmapping/delete/${APP_NAME}/${RISK_ID}/${COMPANY_ID}/`);
    return response.data;
  },

  //Workpapers

  fetchWorkpaper: async () => {
    const response = await axiosInstance.get(`audit/workpapers/`);
    return response.data;
  },

  fetchWorkpapersById: async (workpaperID) => {
    const response = await axiosInstance.get(`audit/testing/${workpaperID}/`);
    return response.data;
  },

  fetchWorkpapersByApp: async (appID, companyID, projectID) => {
    const response = await axiosInstance.get(`audit/workpapers/${appID}/${companyID}/${projectID || 'all'}/`);
    return response.data;
  },

  fetchWorkpapersByAppControl: async (appID, companyID, controlID) => {
    const response = await axiosInstance.get(`audit/workpapersbycontrol/${appID}/${companyID}/${controlID}/`);
    return response.data;
  },

  createWorkpaper: async (workpaperData) => {
    const response = await axiosInstance.post(`audit/workpapers/`, workpaperData);
    return response.data;
  }, 

  updateWorkpaper: async (workpaperID, workpaperData) => {
    const response = await axiosInstance.put(`audit/testing/${workpaperID}/`, workpaperData);
    return response.data;
  },

  deleteWorkpaper: async (workpaperID) => {
    const response = await axiosInstance.delete(`audit/workpapers/${workpaperID}/`);
    return response.data;
  },

  //PROCEDURES LIBRARY
  
  fetchProcedures: async () => {
    const response = await axiosInstance.get(`audit/testprocedures/`);
    return response.data;
  },

  fetchProceduresById: async (controlID) => {
    const response = await axiosInstance.get(`audit/testprocedures/${controlID}/`);
    return response.data;
  },

  fetchProceduresByControlId: async (controlID) => {
    const response = await axiosInstance.get(`audit/testprocedures/control/${controlID}/`);
    return response.data;
  },

  createProcedures: async (procedureData) => {
    const response = await axiosInstance.post(`audit/testprocedures/`, procedureData);
    return response.data;
  }, 

  updateProcedures: async (procedureName, procedureData) => {
    const response = await axiosInstance.put(`audit/testprocedures/${procedureName}/`, procedureData);
    return response.data;
  },

  deleteProcedures: async (procedureName) => {
    const response = await axiosInstance.delete(`audit/testprocedures/${procedureName}/`);
    return response.data;
  },

   //WORKPAPER DETAILS LIBRARY
  
   fetchWorkpaperDetails: async () => {
    const response = await axiosInstance.get(`audit/workpaperdetails/`);
    return response.data;
  },

  fetchWorkpaperDetailsById: async (workpaperID) => {
    const response = await axiosInstance.get(`audit/workpaperdetailsbyid/${workpaperID}/`);
    return response.data;
  },

  createWorkpaperDetails: async (workpaperDetails) => {
    const response = await axiosInstance.post(`audit/workpaperdetails/`, workpaperDetails);
    return response.data;
  }, 

  updateWorkpaperDetails: async (workpaperID, workpaperDetails) => {
    const response = await axiosInstance.put(`audit/workpaperdetails/${workpaperID}/`, workpaperDetails);
    return response.data;
  },

  deleteWorkpaperDetails: async (workpaperID) => {
    const response = await axiosInstance.delete(`audit/workpaperdetails/${workpaperID}/`);
    return response.data;
  },

  // Generate test procedures using OpenAI
  generateTestProcedure: async (data) => {
    try {
        const response = await axiosInstance.post('audit/generate-procedure/', {
            control_title: data.control_title,
            procedure_type: data.procedure_type
        });
        return response.data;
    } catch (error) {
        console.error('Error generating test procedure:', error);
        throw error;
    }
  },

  generateControlDescription: async (data) => {
    try {
        const response = await axiosInstance.post('audit/generate-control-description/', {
            control_title: data.control_title,
            control_type: data.control_type,
            control_category: data.control_category,
            control_domain: data.control_domain
        });
        return response.data;
    } catch (error) {
        console.error('Error generating control description:', error);
        throw error;
    }
  },

  AnalyzeResult: async (designProcedure, designResult) => {
    const response = await axiosInstance.post('audit/analyze-design-result/', {
      design_procedure: designProcedure,
      design_result: designResult
    });
    return response.data;
  },


  uploadDesignEvidence: async (workpaperId, formData) => {
    try {
      formData.append('workpaper_details', workpaperId);
      const response = await axiosInstance.post(
        'audit/workpaper-design-evidence/',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error uploading design evidence:', error);
      throw error;
    }
  },

  fetchDesignEvidence: async (workpaperId) => {
    try {
      const response = await axiosInstance.get(`audit/workpaper-design-evidence/?workpaper_details=${workpaperId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching design evidence:', error);
      throw error;
    }
  },

  deleteDesignEvidence: async (fileId) => {
    try {
      const response = await axiosInstance.delete(`audit/workpaper-design-evidence/${fileId}/`);
      return response.data;
    } catch (error) {
      console.error('Error deleting design evidence:', error);
      throw error;
    }
  },

  uploadInterimEvidence: async (workpaperId, formData) => {
    try {
      formData.append('workpaper_details', workpaperId);
      const response = await axiosInstance.post(
        'audit/workpaper-interim-evidence/',  
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        } 
      );
      return response.data;
    } catch (error) {
      console.error('Error uploading interim evidence:', error);
      throw error;
    }
  },

  fetchInterimEvidence: async (workpaperId) => {
    try {
      const response = await axiosInstance.get(`audit/workpaper-interim-evidence/?workpaper_details=${workpaperId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching interim evidence:', error);
      throw error;
    }
  },

  deleteInterimEvidence: async (fileId) => {
    try {
      const response = await axiosInstance.delete(`audit/workpaper-interim-evidence/${fileId}/`);
      return response.data;
    } catch (error) {
      console.error('Error deleting interim evidence:', error);
      throw error;
    }
  },

  uploadRFEvidence: async (workpaperId, formData) => {
    try {
      formData.append('workpaper_details', workpaperId);
      const response = await axiosInstance.post(
        'audit/workpaper-rf-evidence/',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error uploading RF evidence:', error);
      throw error;
    }
  },

  fetchRFEvidence: async (workpaperId) => {
    try {
      const response = await axiosInstance.get(`audit/workpaper-rf-evidence/?workpaper_details=${workpaperId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching RF evidence:', error);
      throw error;
    }
  },

  deleteRFEvidence: async (fileId) => {
    try {
      const response = await axiosInstance.delete(`audit/workpaper-rf-evidence/${fileId}/`);
      return response.data;
    } catch (error) {
      console.error('Error deleting RF evidence:', error);
      throw error;
    }
  },

  uploadFinalEvidence: async (workpaperId, formData) => {
    try {
      formData.append('workpaper_details', workpaperId);
      const response = await axiosInstance.post(
        'audit/workpaper-final-evidence/',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error uploading final evidence:', error);
      throw error;
    }
  },

  fetchFinalEvidence: async (workpaperId) => {
    try {
      const response = await axiosInstance.get(`audit/workpaper-final-evidence/?workpaper_details=${workpaperId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching final evidence:', error);
      throw error;
    }
  },

  deleteFinalEvidence: async (fileId) => {
    try {
      const response = await axiosInstance.delete(`audit/workpaper-final-evidence/${fileId}/`);
      return response.data;
    } catch (error) {
      console.error('Error deleting final evidence:', error);
      throw error;
    }
  },

  // AUDIT REQUESTS

  fetchRequestById: async (requestId) => {
    const response = await axiosInstance.get(`audit/requests-by-id/${requestId}/`);
    return response;
  },

  updateRequest: async (requestId, requestData) => {
    const response = await axiosInstance.put(`audit/requests-by-id/${requestId}/`, requestData);
    return response.data;
  },

  deleteRequest: async (requestId) => {
    const response = await axiosInstance.delete(`audit/requests-by-id/${requestId}/`);
    return response.data;
  },

  getAuditRequests: async (params = {}) => {
    try {
      const response = await axiosInstance.get('audit-requests/', { params });
      return response;
    } catch (error) {
      console.error('Error fetching audit requests:', error);
      throw error;
    }
  },

  createAuditRequest: async (formData) => {
    return await axiosInstance.post('audit-requests/', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },

  createBulkAuditRequest: async (formData) => {
    return await axiosInstance.post('audit-requests/bulk/', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      onUploadProgress: (progressEvent) => {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        console.log('Upload progress:', percentCompleted);
      }
    });
  },

  updateAuditRequest: async (id, requestData) => {
    const response = await axiosInstance.put(`audit-requests/${id}/`, requestData);
    return response.data;
  },

  deleteAuditRequest: async (id) => {
    const response = await axiosInstance.delete(`audit-requests/${id}/`);
    return response.data;
  },

  uploadAuditRequestEvidence: async (formData) => {
    return await axiosInstance.post(`audit-request-evidence/`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
  },

  deleteRequestEvidence: async (fileId) => {
    return await axiosInstance.delete(`audit-request-evidence/${fileId}/`);
  },

  addComment: async (requestId, commentData) => {
    const response = await axiosInstance.post(`audit-requests/${requestId}/add_comment/`, commentData);
    return response.data;
  },

  getComments: async (requestId) => {
    const response = await axiosInstance.get(`audit-requests/${requestId}/get_comments/`);
    return response.data;
  },

  updateComment: async (requestId, commentId, commentData) => {
    const response = await axiosInstance.put(`audit-requests/${requestId}/update_comment/${commentId}/`, commentData);
    return response.data;
  },

  deleteComment: async (requestId, commentId) => {
    const response = await axiosInstance.delete(`audit-requests/${requestId}/delete_comment/${commentId}/`);
    return response.data;
  },

  markCommentAsRead: async (requestId, commentId) => {
    const response = await axiosInstance.post(`audit-requests/${requestId}/mark_comment_as_read/${commentId}/`);
    return response.data;
  },

  // Audit List for Access Management
  fetchAuditList: async () => {
    const response = await axiosInstance.get('audit/auditlist/');
    return response.data;
  },

  sendFollowUp: async (requestId) => {
    const response = await axiosInstance.post(`audit-requests/${requestId}/send_followup/`);
    return response.data;
  },

  generateDesignDocumentation: async (documentationData) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/audit/generate-design-documentation/`,
        documentationData,
        {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`,
            'Content-Type': 'application/json',
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error generating design documentation:', error);
      throw error;
    }
  },

  fetchAuditRequestsByWorkpaper: async (workpaperId) => {
    try {
      const response = await axiosInstance.get(`audit-requests/by-workpaper/${workpaperId}/`);
      return response.data;
    } catch (error) {
      console.error('Error fetching audit requests by workpaper:', error);
      throw error;
    }
  },

  getRequestEvidenceDetails: async (requestId) => {
    try {
      const response = await axiosInstance.get(`audit-request-evidence/?audit_request=${requestId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching request evidence details:', error);
      throw error;
    }
  },

  downloadRequestEvidence: async (fileId) => {
    try {
      const response = await axiosInstance.get(`audit-request-evidence/${fileId}/download/`, {
        responseType: 'blob',
        headers: {
          'Accept': '*/*',
          'Content-Type': 'application/json',
        }
      });
      return response;
    } catch (error) {
      console.error('Download failed:', error);
      throw error;
    }
  },

  downloadAllRequestEvidence: async (requestId) => {
    try {
      const response = await axiosInstance.get(`audit-request-evidence/download-all/${requestId}/`, {
        responseType: 'blob'
      });
      
      // Create blob link to download
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'evidence.zip');
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error downloading all evidence:', error);
      throw error;
    }
  },

  // Evidence Download Methods
  downloadEvidence: async (evidenceFile) => {
    try {
      // If we have a direct file URL, use it
      if (evidenceFile.file_name && evidenceFile.file_name.startsWith('http')) {
        const response = await axiosInstance.get(evidenceFile.file_name, {
          responseType: 'blob',
          headers: {
            'Accept': '*/*'
          }
        });
        return response;
      }
      
      // Fallback to API endpoint if no direct URL
      const response = await axiosInstance.get(`audit-request-evidence/${evidenceFile.id}/download/`, {
        responseType: 'blob',
        headers: {
          'Accept': '*/*'
        }
      });
      return response;
    } catch (error) {
      console.error('Download failed:', error);
      throw error;
    }
  },

  downloadAllEvidence: async (requestId) => {
    try {
      const response = await axiosInstance.get(`audit-requests/${requestId}/download-all/`, {
        responseType: 'blob'
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Review Notes
  fetchReviewNotes: async (workpaperId) => {
    const response = await axiosInstance.get(`audit/reviewnotes/${workpaperId}/`);
    return response.data;
  },

  createReviewNote: async (noteData) => {
    const response = await axiosInstance.post(`audit/reviewnotes/`, noteData);
    return response.data;
  },

  updateReviewNote: async (noteId, noteData) => {
    const response = await axiosInstance.put(`audit/reviewnotes/${noteId}/`, noteData);
    return response.data;
  },

  deleteReviewNote: async (noteId) => {
    const response = await axiosInstance.delete(`audit/reviewnotes/${noteId}/`);
    return response.data;
  },

  // New method that takes a custom URL for updating data
  updateDataWithCustomUrl: async (url, data) => {
    try {
      console.log(`Attempting to update data with custom URL: ${url}`);
      console.log(`Request data:`, data);
      
      // Try PUT first
      const response = await axiosInstance.put(url, data);
      console.log('Update successful with PUT');
      return response.data;
    } catch (putError) {
      console.error(`PUT request failed for ${url}:`, putError.message);
      
      // If PUT fails, try PATCH
      try {
        console.log('Trying PATCH request instead');
        const response = await axiosInstance.patch(url, data);
        console.log('Update successful with PATCH');
        return response.data;
      } catch (patchError) {
        console.error(`PATCH request also failed for ${url}:`, patchError.message);
        throw putError; // Throw the original error
      }
    }
  },

  // Audit Planning
  fetchAuditPlans: async (auditId) => {
    try {
      const response = await axiosInstance.get(`audit/plans/by-audit/${auditId}/`);
      return response.data;
    } catch (error) {
      console.error('Error fetching audit plans:', error);
      throw error;
    }
  },

  fetchAuditPlanById: async (planId) => {
    try {
      const response = await axiosInstance.get(`audit/plans/${planId}/`);
      return response.data;
    } catch (error) {
      console.error('Error fetching audit plan by ID:', error);
      throw error;
    }
  },

  createAuditPlan: async (planData) => {
    try {
      // Ensure DOCUMENT_TYPE is set (default to General if not provided)
      const planDataWithDocType = {
        ...planData,
        DOCUMENT_TYPE: planData.DOCUMENT_TYPE || 'General'
      };
      
      const response = await axiosInstance.post('audit/plans/', planDataWithDocType);
      return response.data;
    } catch (error) {
      console.error('Error creating audit plan:', error);
      throw error;
    }
  },

  updateAuditPlan: async (planId, planData) => {
    try {
      const response = await axiosInstance.put(`audit/plans/${planId}/`, planData);
      return response.data;
    } catch (error) {
      console.error('Error updating audit plan:', error);
      throw error;
    }
  },

  deleteAuditPlan: async (planId) => {
    try {
      const response = await axiosInstance.delete(`audit/plans/${planId}/`);
      return response.data;
    } catch (error) {
      console.error('Error deleting audit plan:', error);
      throw error;
    }
  },

  fetchInternalAuditUsers: async (auditId) => {
    try {
      console.log(`Fetching internal audit users for audit ID: ${auditId}`);
      const response = await axiosInstance.get(`audit/internal-users/${auditId}/`);
      console.log('Internal audit users response:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error fetching internal audit users:', error);
      console.error('Error details:', error.response?.data || 'No response data');
      throw error;
    }
  },

  // Add new methods to fetch plans by document type and to fetch plan documents
  fetchAuditPlansByType: async (auditId, documentType = 'General') => {
    try {
      console.log(`[DEBUG] fetchAuditPlansByType called with auditId=${auditId}, documentType='${documentType}'`);
      
      // Ensure document type is properly encoded in the URL
      const encodedDocType = encodeURIComponent(documentType);
      const url = `audit/plans/by-audit/${auditId}/?document_type=${encodedDocType}`;
      console.log(`[DEBUG] Making API call to: ${url}`);
      
      const response = await axiosInstance.get(url);
      console.log(`[DEBUG] Response received with ${response.data.length} items`);
      
      // Validate that the response contains items with the expected document type
      const mismatchedItems = response.data.filter(item => item.DOCUMENT_TYPE !== documentType);
      if (mismatchedItems.length > 0) {
        console.warn(`[WARNING] API returned ${mismatchedItems.length} items with non-matching document types`);
      }
      
      return response.data;
    } catch (error) {
      console.error(`Error fetching audit plans for type ${documentType}:`, error);
      throw error;
    }
  },

  // Fetch unique document types for a project
  fetchAuditPlanDocuments: async (auditId) => {
    try {
      const response = await axiosInstance.get(`audit/plans/documents/${auditId}/`);
      return response.data;
    } catch (error) {
      console.error('Error fetching audit plan documents:', error);
      throw error;
    }
  },
};

export default auditService;
